// removed by extract-text-webpack-plugin
module.exports = {"rating-mobile":"Mobile__rating-mobile__1yqv4","rating-img":"Mobile__rating-img__2e7Oi","rating-img-wrapper":"Mobile__rating-img-wrapper__aZxle"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Safety/Rating/Mobile/Mobile.scss
// module id = 471
// module chunks = 0